/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     Name: public.routes.tsx
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 IMPORTS
***************************************************************************************************************************/
import { type FunctionComponent } from 'react';
import { type RouteObject, useRoutes } from 'react-router-dom';

import Utils from '@/utils';
import Links from '@/constants/links';

import HomePage from '@/pages/home.page';
import ProjectsPage from '@/pages/projects.page';
import ContactUsPage from '@/pages/contact-us.page';
import CareersPage from '@/pages/careers.page';
import Layouts from '@/layouts';
/**************************************************************************************************************************
 TYPES / GLOBAL DEFINITIONS
***************************************************************************************************************************/
const PUBLIC_ROUTES: RouteObject[] = [
  {
    id: Utils.getUniqueId('route'),
    path: Links.Public.HOME,
    element: <Layouts.Public />,
    children: [
      {
        id: Utils.getUniqueId('route'),
        path: Links.Public.HOME,
        element: <HomePage />
      },
      {
        id: Utils.getUniqueId('route'),
        path: Links.Public.PROJECTS,
        element: <ProjectsPage />
      },
      {
        id: Utils.getUniqueId('route'),
        path: Links.Public.CONTACT_US,
        element: <ContactUsPage />
      },
      {
        id: Utils.getUniqueId('route'),
        path: Links.Public.CAREERS,
        element: <CareersPage />
      }
    ]
  },
  {
    id: Utils.getUniqueId('route'),
    path: Links.Common.UNKNOWN,
    element: <></>
  }
];
/**************************************************************************************************************************
 IMPLEMENTATIONS
***************************************************************************************************************************/
const PublicRoutes: FunctionComponent = () => {
  const routes = useRoutes(PUBLIC_ROUTES);

  return <>{routes}</>;
};

export default PublicRoutes;
